import React, { forwardRef, memo, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./NumericInput.scss";
import { TextInput } from "./TextInput";

/* eslint-disable-next-line react/display-name */
export const ArtworkNumericInput = memo(
  forwardRef(({ className, onDimensionChange, afterInput, inputMode = "numeric", ...rest }, ref) => {

    const handleDimensionChange = useCallback((e) => {
      const { name, value } = e.target;
      if (onDimensionChange) {
        onDimensionChange(name, parseFloat(value));
      }
    }, [onDimensionChange]);

    return (
      <TextInput
        inputMode={inputMode}
        {...rest}
        type="number"
        className={classNames(styles.numericInput, className)}
        ref={ref}
        afterInput={afterInput}
        onChange={handleDimensionChange}
      />
    );
  })
);

ArtworkNumericInput.propTypes = {
  afterInput: PropTypes.node,
  className: PropTypes.string
};
